(function () {
  'use strict';

  angular
    .module('web2print')
    .directive('box', box);

  /* @ngInject */
  function box () {
    const directive = {
      restrict: 'EA',
      templateUrl: 'components/shared/box/box.directive.html',
      transclude: true,
      scope: {
        hasPadding: '=',
        sidebar: '=',
        collapsible: '=',
        boxTitle: '='
      },
      controller: BoxController,
      controllerAs: 'box',
      bindToController: true
    };

    return directive;
  }

  BoxController.$inject = [];

  /* @ngInject */
  function BoxController () {
    const vm = this;

    vm.hasActions = hasActions;
    vm.toggleCollapse = toggleCollapse;

    console.log('BoxController : vm', vm);

    activate();

    ////////////////////////

    function activate () {
      vm.hasPadding = typeof (vm.hasPadding) === undefined || vm.hasPadding;
      vm.isCollapsed = !!vm.collapsible;
    }

    function hasActions () {
      return !!vm.collapsible;
    }

    function toggleCollapse () {
      vm.isCollapsed = !vm.isCollapsed;
      console.log('BoxController : toggleCollapse');
    }
  }
})();
